import { render, staticRenderFns } from "./PinList.vue?vue&type=template&id=c4b99b92"
import script from "./PinList.vue?vue&type=script&lang=js"
export * from "./PinList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports